import React from 'react';
import useClinicForm from '../../CreateClinic/hooks/useClinicForm';
import { ModifyClinicProps } from '../../types';
import ModifyClinicMainTab from './tabs/ClinicMainTab';
import ClinicTabs from './tabs/ClinicTabs';
import { ClinicTab } from './tabs/types';
import TabPanel from '../../../Shared/Tabs/TabPanel';
import ClinicConditionsTab from './tabs/ClinicConditionsTab';
import ClinicListingOrganisationsTab from './tabs/ClinicListingOrganisationsTab';
import ClinicExcludedOrganisationsTab from './tabs/ClinicExcludedOrganisationsTab';
import ClinicFulfilmentTab from './tabs/ClinicFulfilmentTab';
import ClinicPrescribersTab from './tabs/ClinicPrescribersTab';
import useNavigateToProductPageOnProductTab from './hooks/useNavigateToProductPageOnProductTab';
import { FulfilmentTypeEnum } from '../../../../apis/clinics/types';
import CreateClinicHeader from '../../CreateClinic/components/CreateClinicHeader';
import GlobalDefaultClinicBanner from './GlobalDefaultClinicBanner';

const ModifyClinic = ({ clinic }: ModifyClinicProps) => {
  const form = useClinicForm({ clinic, isCreateMode: false });
  const [currentTab, setCurrentTab] = React.useState(ClinicTab.GENERAL);

  useNavigateToProductPageOnProductTab(clinic._id, currentTab);

  const fulfilmentType = clinic.fulfilment_type || FulfilmentTypeEnum.SPECIFIC_ORGANISATIONS;
  const isGlobalDefaultClinic = clinic.selection_visibility === 'global_default';

  return (
    <>
      <CreateClinicHeader title={clinic.name} />

      {isGlobalDefaultClinic && <GlobalDefaultClinicBanner />}

      <ClinicTabs currentTab={currentTab} onChange={setCurrentTab} />

      <TabPanel value={ClinicTab.GENERAL} currentValue={currentTab}>
        <ModifyClinicMainTab form={form} clinic={clinic} />
      </TabPanel>

      <TabPanel value={ClinicTab.CONDITIONS} currentValue={currentTab}>
        <ClinicConditionsTab clinic={clinic} form={form} />
      </TabPanel>

      <TabPanel value={ClinicTab.LISTING_ORGANISATIONS} currentValue={currentTab}>
        <ClinicListingOrganisationsTab clinic={clinic} fulfilmentType={fulfilmentType} />
      </TabPanel>

      <TabPanel value={ClinicTab.EXCLUDED_ORGANISATIONS} currentValue={currentTab}>
        <ClinicExcludedOrganisationsTab clinic={clinic} />
      </TabPanel>

      <TabPanel value={ClinicTab.FULFILMENT} currentValue={currentTab}>
        <ClinicFulfilmentTab clinic={clinic} />
      </TabPanel>

      <TabPanel value={ClinicTab.PRESCRIBERS} currentValue={currentTab}>
        <ClinicPrescribersTab clinic={clinic} />
      </TabPanel>
    </>
  );
};

export default ModifyClinic;
